module.exports = __webpack_public_path__ + "static/media/logo.8aedd77e.png";